import { render, staticRenderFns } from "./AuthorizationStatusBadge.vue?vue&type=template&id=40b9de5c&scoped=true&"
import script from "./AuthorizationStatusBadge.vue?vue&type=script&lang=js&"
export * from "./AuthorizationStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationStatusBadge.vue?vue&type=style&index=0&id=40b9de5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b9de5c",
  null
  
)

export default component.exports